import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './user';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user: userStore
    },
    state: {
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
            identity: '',
            type: null
        }
    },
    mutations: {
        SOCKET_ONOPEN(state, event) {
            state.socket.isConnected = true;
        },
        SOCKET_ONCLOSE(state, event) {
            state.socket.isConnected = false;
        },
        SOCKET_ONERROR(state, event) {
            console.error(state, event);
        },
        // default handler called for all methods
        SOCKET_ONMESSAGE(state, message) {
            console.log('SOCKET_ONMESSAGE', message);
            state.socket.message = message;
        },
        SOCKET_CONNECT(state, message) {
            state.socket.identity = message.identity;
            console.log('Socket: Established connection with identity: ' + state.socket.identity);
        },
        // mutations for reconnect methods
        SOCKET_RECONNECT(state, count) {
            console.log('SOCKET_RECONNECT');
            console.info(state, count);
        },
        SOCKET_RECONNECT_ERROR(state) {
            console.log('SOCKET_RECONNECT_ERROR');
            state.socket.reconnectError = true;
        },
        setSocketType(state, type) {
            state.socket.type = type;
        },
        setNavbarVisibility(state, visible) {
            state.navbarVisible = visible;
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js